declare global {
	interface Window {
		WebSocket: typeof WebSocket;
		MozWebSocket: typeof WebSocket;
	}
}

const WS = (function WS(global: Window): typeof WebSocket {
	if (global.WebSocket) {
		return global.WebSocket;
	}
	if (global.MozWebSocket) {
		return global.MozWebSocket;
	}
	return global.WebSocket;
})(window);

export default WS;
